
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function useSplashScreen() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
  const initializeApp = async () => {
    const startTime = Date.now();

    try {
      const API_URL = import.meta.env.VITE_API_URL;
      const AUTH_TYPE = 1;
      
      const fullUrl = `${API_URL}/api/amibit/fwp/token`;
      console.log("🔍 Fetching from:", fullUrl);

      const response = await fetch(
        fullUrl,
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json",
          },
          body: JSON.stringify({
            type: AUTH_TYPE,
          }),
        }
      );

      console.log("📡 Response Status:", response.status);
      console.log("📡 Response Headers:", {
        contentType: response.headers.get('content-type'),
      });

      if (!response.ok) {
        const errorText =
          await response.text();

        console.error("❌ Error Response:", errorText);
        throw new Error(
          `Failed to fetch token. Status: ${response.status}. Response: ${errorText}`
        );
      }

      const responseText = await response.text();
      console.log("📝 Raw Response:", responseText);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (parseErr) {
        console.error("❌ JSON Parse Error. First 500 chars:", responseText.substring(0, 500));
        throw new Error(
          `Invalid JSON response: ${responseText.substring(0, 200)}`
        );
      }

      const token =
        data?.data?.token;

      if (!token) {
        throw new Error(
          "Token not received from API"
        );
      }

      sessionStorage.setItem(
        "AUTH_TOKEN",
        token
      );

      sessionStorage.setItem(
        "AUTH_TYPE",
        String(AUTH_TYPE)
      );

      const elapsed =
        Date.now() - startTime;

      const remaining =
        Math.max(
          0,
          5000 - elapsed
        );

      setTimeout(() => {
        navigate("/login", {
          replace: true,
        });
      }, remaining);

    } catch (err) {

      console.error(
        "Splash Screen Error:",
        err
      );

      setError(
        err instanceof Error
          ? err.message
          : "Unable to initialize application."
      );

      setLoading(false);
    }
  };

  initializeApp();
}, [navigate]);

  return {
    loading,
    error,
  };
}